export type EpcInvitationKind = 'EOI' | 'RFQ' | 'RFT';

export const EPC_INVITATION_KIND_LABEL: Record<EpcInvitationKind, string> = {
  EOI: 'Expression of Interest',
  RFQ: 'Request for Quotation',
  RFT: 'Request for Tender',
};

export function epcInvitationKind(raw: unknown): EpcInvitationKind | null {
  const value = String(raw ?? '').trim().toUpperCase();
  if (value === 'EOI' || value === 'RFQ' || value === 'RFT') return value;
  return null;
}

export function epcInvitationKindLabel(raw: unknown): string {
  const kind = epcInvitationKind(raw);
  return kind ? EPC_INVITATION_KIND_LABEL[kind] : 'Prequalification';
}

export const EOI_OUTCOME_OPTIONS = [
  'Draft',
  'In preparation',
  'Submitted',
  'Under review',
  'Shortlisted',
  'Not shortlisted',
  'Withdrawn',
  'No response',
];

export const TENDER_INVITATION_STATUSES = [
  'Draft',
  'In preparation',
  'Clarification',
  'Submitted',
  'Under evaluation',
  'Revised',
  'Awarded',
  'Lost',
  'Withdrawn',
  'No bid',
];

export const RFT_STATUS_OPTIONS = [...TENDER_INVITATION_STATUSES, 'BAFO'];

export const CLIENT_INVITATION_NOTE =
  'This is the client invitation we respond to, not a supplier enquiry.';
